import { render } from "./ComponenteGasSwap.vue?vue&type=template&id=c7a5f17e&scoped=true"
import script from "./ComponenteGasSwap.vue?vue&type=script&lang=js"
export * from "./ComponenteGasSwap.vue?vue&type=script&lang=js"

import "./ComponenteGasSwap.vue?vue&type=style&index=0&id=c7a5f17e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c7a5f17e"]])

export default __exports__